//import api from '@/api/mock';
import API from '@aws-amplify/api';
export default {
  namespaced: true,
  state: {
    gateways: [],
    loading: false
  },
  mutations: {
    loading(state, payload) {
      state.loading = payload;
    },
    set(state, payload) {
      const found = state.gateways.findIndex(
        item => item.gateway == payload.gateway
      );
      console.log('Found: ', found);
      if (found >= 0) {
        state.gateways[found] = payload;
      } else state.gateways.push(payload);
    },
    reset(state) {
      state.features = null;
      state.id = null;
    }
  },
  actions: {
    async get(context, id) {
      let gateway = context.state.gateways.find(item => {
        return item.gateway == id;
      });
      if (gateway) return gateway;
      const features = await API.get(
        'ipWayAPI',
        '/gateways/' + id + '/features'
      );
      console.log('Loaded features from gateway ' + id, features);
      gateway = { gateway: id, ...features };
      context.commit('set', gateway);
      return gateway;
    },

    put({ commit }, params) {
      console.log('putting features about gateway');
      commit('loading', true);
      return API.put('ipWayAPI', '/gateways/features', {
        body: params
      }).then(() => {
        commit('set', params);
      });
    }
  }
};
